import { render, staticRenderFns } from "./CanNotAccess.vue?vue&type=template&id=466b2a60&scoped=true&lang=html&"
import script from "./CanNotAccess.vue?vue&type=script&lang=js&"
export * from "./CanNotAccess.vue?vue&type=script&lang=js&"
import style0 from "./CanNotAccess.vue?vue&type=style&index=0&id=466b2a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b2a60",
  null
  
)

component.options.__file = "CanNotAccess.vue"
export default component.exports